"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : DYNAMIC TABLE : STYLES --------------- ++++++++++ */


var _default = {
  dynamictable: {
    width: '100%',
    overflow: 'auto',
    '& table, th, td, tr': {
      border: "1px solid rgb(242, 244, 248)"
    },
    '& table': {
      position: 'relative',
      // need for fixed header
      borderCollapse: 'collapse',
      width: '100%',
      // '& tbody': {
      //     '& tr': {
      //         opacity: '0',
      //         animationName: 'fadeInUp',
      //         animationDuration: '.2s',
      //         animationFillMode: 'forwards',
      //         extend: nthChildIterator(50, .5, .03) // 50 rows right now, if this changes in the component, change this value
      //     }
      // },
      '& tr.nodata': {
        '& td': {
          background: 'transparent',
          height: (0, _index.pxToEm)(153),
          color: 'rgb(192, 201, 220)',
          fontSize: (0, _index.pxToEm)(42),
          fontWeight: '500',
          textAlign: 'center',
          verticalAlign: 'middle'
        }
      },
      '& th': {
        position: 'sticky',
        top: '0',
        height: (0, _index.pxToEm)(54),
        textAlign: 'left',
        padding: "".concat((0, _index.pxToEm)(8), " ").concat((0, _index.pxToEm)(20)),
        background: _index.theme.color.supporting.medium.swatch,
        color: _index.theme.color.supporting.medium.contrast,
        fontSize: (0, _index.pxToEm)(14),
        fontWeight: 'normal',
        pointerEvents: 'none',
        '&.sort-true': {
          cursor: 'pointer',
          pointerEvents: 'all'
        },
        '&.answerCount': {
          minWidth: (0, _index.pxToEm)(110)
        },
        '& .icon': {
          marginLeft: (0, _index.pxToEm)(10)
        }
      },
      '& td': {
        background: _index.theme.color.light.light.swatch,
        padding: (0, _index.pxToEm)(20),
        fontSize: (0, _index.pxToEm)(14),
        lineHeight: '1.4',
        '&.flag': {
          textAlign: 'center'
        },
        '&.answerCount': {
          width: (0, _index.pxToEm)(110)
        }
      }
    },
    '& .flagged-true': {
      '& .answer, .classification, .flag': {
        background: _index.theme.color.attention.medium.swatch,
        color: _index.theme.color.attention.medium.contrast
      }
    },
    '& .mainRow': {
      borderTop: "8px solid rgb(242, 244, 248)"
    }
  }
};
exports.default = _default;